module.exports = __webpack_public_path__ + "static/media/spond_logo_white.741b52d5.svg";